import Component from './Component';
import SearchMap from './SearchMap';
// import FavButton from './FavButton';
import { initFavButton } from '../lib/FavButtonsHelper';
import { initAddToTripCardBtnListeners } from '../lib/AddToTripCardBtnHelper';


export default class SearchSubmit extends Component {

  load() {
    this.isInitialMapView = true;
    this.isCategoryFromQueryString = true;
    this.initSubmitOnChange();
    this.searchRefresh();

    super.load();
  }


  //submit to api on change
  initSubmitOnChange() {
    $('.search-filters__right, .search-filters__field-group--category').find('input').on('change', (evt) => {
      setTimeout(() => {
        this.isCategoryFromQueryString = false;
        //$(e.currentTarget.form).submit();

        this.searchRefresh();
      }, 1);
    });


    //category dropdown refresh
    $('#search-filters-category').on('change', (evt) => {
      const target = evt.currentTarget;

      this.subcategoryRefresh(target.value);
      this.searchRefresh();

      this.showDateDropdown(target.value === 'EVENT' || target.value === '');

      this.toggleDropdown($('#button-category'));
    });


    //location dropdown refresh
    $('#search-filters-location, #search-filters-sort-desktop').on('change', (evt) => {
      // Get the button element
      const buttonElement = document.querySelector('.search-filters__display-button--map');

      if (buttonElement) {
        // Check if data-target contains #map-layout
        const hasMapLayoutDataTarget = buttonElement.getAttribute('data-target') === '#map-layout';
        // Check if class contains --active
        const hasActiveClass = buttonElement.classList.contains('search-filters__display-button--active');

        if (hasMapLayoutDataTarget && hasActiveClass) {
          this.refreshMap();
        } else {
          this.searchRefresh();
        }
      }
    });

    $('#search-filters-sort-desktop, #search-filters-sort-mobile').on('change', (evt) => {
      this.searchRefresh();
    });

    //sub-category dropdown refresh
    $('#fieldset-type .jcf-option').on('click', () => {
      this.searchRefresh();
    });


    //Set submit of apply and cancel buttons
    $('.search-filters__field-group').find('[data-submit]').on('click', (e) => {

      this.searchRefresh();

      const parentContainer = $(e.target).parent(); // Get the direct parent container
      const closestButton = parentContainer.closest('#fieldset-date'); // Get the closest ancestor with the ID #fieldset-date
      console.log('search-filters__field-group reached');
      if (closestButton.hasClass('search-filters__field-group--open')) {

        $('body').removeClass('fieldset-open');

        if (e.target.classList.value.includes('--cancel')) {
        } else { closestButton.removeClass('search-filters__field-group--open').addClass('search-filters__field-group--close'); }

      } else {
        console.log("No class update needed.");
      }

    });


    //search text field refresh
    $('#search-bar-input').on('keydown', (evt) => {
      if (evt.key === 'Enter') {
        evt.preventDefault();

        this.searchRefresh();
        return false;
      }
    });


    //refresh map on click
    $('[data-toggle="display"]').on('click', (el) => {
      if (!this.isInitialMapView) {
        if (el != undefined && el.currentTarget.attributes["data-target"].value === '#map-layout') {
          setTimeout(() => {
            this.searchRefresh(true);
          }, 300);
        } else {
          this.searchRefresh();
        }
      }
      else {
        this.isInitialMapView = false;
      }
    });

    this.refreshPagination();
  }


  searchRefresh(runRefreshMap) {
    const data = this.createSearchParameters();
    console.log("createSearchParameters", data);
    //data.cat = "Article";
    const queryString = this.convertToQueryString(data);
    const url = "/umbraco/api/searchapi/get?" + queryString;

    $.ajax({
      type: "GET",
      url: url,
      dataType: "html"
    }).done((data) => {
      $("#grid-layout").empty().append(data);
      this.refreshPagination();
      const map = $('#map-layout');
      // console.log('search results refreshed.');
      initAddToTripCardBtnListeners(); // add listeners to all trip card buttons
      // if(window.createAddToTripCardBtnListeners) { // only if function exists
      //   window.createAddToTripCardBtnListeners(); // add listeners to all trip card buttons
      // }
      if ((runRefreshMap != undefined && runRefreshMap) || map.is(":visible")) {
        this.refreshMap();
      }

      // init FavButton's
      // console.log(`init fav button's`);
      initFavButton();

    }).fail((errorThrown) => {
      console.log(errorThrown);
      $("#grid-layout").empty().append('No Results found. x');
      this.refreshPagination();
    });
  }


  refreshMap() {
    const searchMap = new SearchMap();
    searchMap.loadSearchMap();
  }


  showDateDropdown(show) {
    const dateDropdown = $('#search-filters-date-wrapper')

    if (show)
      dateDropdown.show();
    else
      dateDropdown.hide();
  }


  convertToQueryString(params) {
    let str = "";

    for (const key in params) {
      const value = params[key];
      if (!value) continue;

      if (str != "") {
        str += "&";
      }
      str += key + "=" + encodeURIComponent(value);
    }

    return str;
  }


  // Will be later used to request new results from the server.
  createSearchParameters() {
    let dateFrom = $('.search-filters__date-container--hidden > input[name="date-from"]').val();
    let dateTo = $('.search-filters__date-container--hidden > input[name="date-to"]').val();

    // Select the input element by its ID
    // const dateInput = document.getElementById('search-filters-date');

    // // Extract the values from the data attributes
    // const eventStartDate = dateInput.getAttribute('data-event-start-date');
    // const eventEndDate = dateInput.getAttribute('data-event-end-date');

    // if (eventStartDate && eventEndDate) {
    //   dateFrom = this.subtractOneDay(eventStartDate);
    //   dateTo = this.subtractOneDay(eventEndDate);
    // }

    let priceFree = $('#search-filters-price')[0];
    let sortValue = $('#search-filters-sort').val($('#search-filters-sort-mobile').val()).val();
    console.log("Sortvalue", sortValue);


    let props = {
      q: this.paramNullCheck(document.getElementById('search-bar-input')),
      sort: sortValue, //this.paramNullCheck($('#search-filters-sort').val($('#search-filters-sort-mobile').val()).val()),
      cat: this.getCategory(),
      p: this.paramNullCheck(document.getElementsByName('page')[0]),
      pageSize: this.paramNullCheck(document.getElementsByName('pagesize')[0]),
      dateFrom: dateFrom === undefined ? null : dateFrom,
      dateTo: dateTo === undefined ? null : dateTo,
      free: priceFree != undefined && priceFree ? priceFree.checked : '',
      reg: this.getRegion(),
      catCms: this.paramNullCheck(document.getElementsByName('categorySetFromCms')[0]),
      subCatCms: this.paramNullCheck(document.getElementsByName('subCategoriesSetFromCms')[0]),
      regionCms: this.paramNullCheck(document.getElementsByName('regionSetFromCms')[0]),
      hideServ: document.getElementById('HideServices') ? document.getElementById('HideServices').checked : true,
      onlyDeals: this.paramNullCheck(document.getElementById('OnlyShowProductsWithDeals')),
      onlyJobs: this.paramNullCheck(document.getElementById('OnlyShowProductsWithJobs')),
      hideSoldOut: document.getElementById('HideSoldOut') ? document.getElementById('HideSoldOut').checked : true,
      id: this.paramNullCheck(document.getElementById('CurrentPageId')),
      tags: this.paramNullCheck(document.getElementsByName('tags')[0]),
      accessibility: this.paramNullCheck(document.getElementById('search-filters-accessibility')),
      currentUrl: window.location.href,
      excludeProductServiceItems: this.paramNullCheck(document.getElementById('ExcludeProductServiceItems')),
      autoPopulateByEventDate: this.paramNullCheck(document.getElementById('AutoPopulateProductsSearch')),
      startDateNextOccurrence: this.paramNullCheck(document.getElementById('StartDateNextOccurrence'))
    };

    let priceEle = $('#price-range');
    let minPrice = this.paramNullCheck(document.getElementsByName('min-price')[0]);
    let maxPrice = this.paramNullCheck(document.getElementsByName('max-price')[0]);

    if (!props.free && (priceEle && !(priceEle.attr('min') == minPrice && priceEle.attr('max') == maxPrice))) {
      props.minPrice = minPrice;
      props.maxPrice = maxPrice;
    }

    let subCat = $('#search-filters-type').val();
    if (typeof (subCat) != 'undefined' && typeof (props.cat) != 'undefined' && props.cat != '') {
      // console.log('props.cat:', props.cat);
      // console.log('props.reg:', props.reg); // region
      // console.log('props.catCms:', props.catCms);
      // console.log('props.regionCms:', props.regionCms);
      // console.log('props.subCatCms:', props.subCatCms);
      props.subCat = subCat.toString();
    }

    //console.log(props);

    return props;
  }

  // Function to subtract one day from a date string
  subtractOneDay(dateString) {
    if (!dateString) return null; // Handle cases where the date is not set
    const date = new Date(dateString); // Convert string to Date object
    date.setDate(date.getDate() - 1); // Subtract one day
    return date.toISOString().split('T')[0]; // Return in YYYY-MM-DD format
  }


  getCategory() {

    if (this.isCategoryFromQueryString) {
      this.isCategoryFromQueryString = false;
      const getCategory = this.getCategoryByQueryString();
      if (getCategory) {
        return getCategory;
      }
    }
    const ele = document.getElementById('search-filters-category');

    if (ele && typeof (ele.value) != 'undefined') {
      return ele.value;
    }

    //fallback to category set by the CMS
    const fallbackEle = document.getElementsByName('category')[0];
    if (fallbackEle && typeof (fallbackEle.value) != 'undefined') {
      return fallbackEle.value;
    }

    return "";
  }


  getCategoryByQueryString() {

    // console.log("getCategoryByQueryString()");

    let categoryJCFElement = document.getElementById("button-category");
    let urlParams = new URLSearchParams(window.location.search);
    //Get category from category query string
    let selectedCategory = urlParams.get('selectedCategory');
    // let CategoryLocation = urlParams.get('CategoryLocation');
    // let Category = urlParams.get('Category');

    // console.log('selectedCategory: ', selectedCategory);
    // console.log('CategoryLocation: ', CategoryLocation);
    // console.log('Category: ', Category);

    // && (!ele && typeof(ele.value) === 'undefined')
    if (selectedCategory && categoryJCFElement) {
      let categories = document.getElementById("search-filters-category");
      let getOurCategoryList = this.getOptionValueByText(categories, selectedCategory);
      if (getOurCategoryList) {
        categoryJCFElement.innerText = getOurCategoryList.innerText.trim();
        categoryJCFElement.setAttribute("data-selected", 1);

        document.getElementsByName("category").innerText = getOurCategoryList.innerText.trim();
        this.subcategoryRefresh(getOurCategoryList.value);

        return getOurCategoryList.value;
      }

      return null;
    }
  }


  /**
   * Finds the value of an option in a select element based on its visible text.
   *
   * @param {HTMLSelectElement} selectElement - The select element to search.
   * @param {string} optionText - The visible text of the option to find.
   * @returns {string|null} The value of the option if found, or null otherwise.
   */
  getOptionValueByText(selectElement, optionText) {
    for (let option of selectElement.options) {
      if (option.text === optionText) {
        return option;
      }
    }
    return null;
  }


  getRegion() {
    let ele = document.getElementById('search-filters-location');
    if (ele && typeof (ele.value) != 'undefined') {
      return ele.value;
    }

    //fallback to category set by the CMS
    let fallbackEle = document.getElementsByName('location')[0];
    if (fallbackEle && typeof (fallbackEle.value) != 'undefined') {
      return fallbackEle.value;
    }

    return "";
  }


  paramNullCheck(ele) {
    if (ele && typeof (ele.value) != 'undefined') {
      return ele.value;
    }

    return "";
  }


  refreshPagination() {
    //Pagination refresh
    $('#frmPagination').find('[data-pagination]').on('click', (e) => {
      e.preventDefault();

      //scroll to top of search
      $([document.documentElement, document.body]).animate({
        scrollTop: $('.search-layout__filters').offset().top
      }, 300);

      document.getElementsByName('page')[0].value = e.currentTarget.getAttribute('data-pagination');
      let searchSubmit = new SearchSubmit();
      searchSubmit.searchRefresh();
    });
  }


  //http://local.new.southaustralia.com/umbraco/api/searchapi/SubCategoriesFilter?selectedCategory=ACCOMM
  subcategoryRefresh(category) {
    if (!category) return;

    const url = "/umbraco/api/searchapi/SubCategoriesFilter?selectedCategory=" + category;

    //Get sub categories from API
    $.ajax({
      async: false,
      type: "GET",
      url: url,
    }).done(function (data) {
      $("#search-filters-type-wrapper").empty().append(data);
    }).fail(function (errorThrown) {
      console.log(errorThrown);
    });

    //run the jcf replace elements to make it perty
    let target = $('.search-filters__type');
    jcf.replace(target);

    //add refresh events on each sub category change
    $('#fieldset-type .jcf-option').on('click', () => {
      this.searchRefresh();
    });

    //Re-add event for the button to open the dropdown
    this.toggleSubCategoryEvent();
  }


  // toggleSubCategoryEvent() {
  //   // Bind openeing/closing on button click (Mobile)
  //   $('#button-subcategory').on('click', (e) => this.toggleDropdown(e));
  // }


  toggleSubCategoryEvent() {
    // Bind openeing/closing on button click (Mobile)
    $('#button-subcategory').on('click', (e) => {
      //console.log('click');
      const target = document.querySelector(e.currentTarget.getAttribute('data-target'));

      if (target) {
        e.preventDefault();

        setTimeout(() => {
          const openClass = `${target.classList[0]}--open`;
          target.classList.toggle(openClass);
          e.currentTarget.classList.toggle('active');

          if (e.currentTarget.getAttribute('data-toggle') === 'fieldset') {
            $('body')[target.classList.contains(openClass) ? 'addClass' : 'removeClass']('fieldset-open');
          } else {
            if (target.classList.contains(openClass)) {
              target.scrollTop = 0;
              $('body').addClass('tray-open');
            } else {
              $('body').removeClass('tray-open');
            }
          }
        }, 0);
      }
    });
  }


  toggleDropdown(button) {

    let $button = $(button)[0];
    const target = document.querySelector($button.getAttribute('data-target'));

    if (target) {
      //this.preventDefault();

      setTimeout(() => {
        const openClass = `${target.classList[0]}--open`;
        target.classList.toggle(openClass);
        $button.classList.toggle('active');

        if ($button.getAttribute('data-toggle') === 'fieldset') {
          $('body')[target.classList.contains(openClass) ? 'addClass' : 'removeClass']('fieldset-open');
        } else {
          if (target.classList.contains(openClass)) {
            target.scrollTop = 0;
            $('body').addClass('tray-open');
          } else {
            $('body').removeClass('tray-open');
          }
        }
      }, 0);
    }
  }

}
